import { useEffect, useState } from 'react';
import { getGuildControl } from '../api';
import { Control } from '../types';

export function useFetchControl(id: any) {
  const [control, setControl] = useState<Control>();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true)
    getGuildControl(id)
    .then(({ data }) => {
      setControl(data);
    })
    .catch((err) => {
      console.log(err);
      setError(err);
    })
    .finally(() => setLoading(false))
  }, [id]);

  return { control, error, loading };
}